/**
 * * Async JSON request
 * @param {user_id} string containing user's UUID
 * @returns {object} object containing all user and store data
 */
export async function postOrganization(user_id: string, object: any) {
    // API URL Endpoint Construction
    const url = `${process.env.REACT_APP_API_URL}/organization`;
    let body = JSON.stringify({ user_id: user_id, stores: object });

    return fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: body,
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(JSON.stringify(response.json()));
            }
            return response.json();
        })
        .catch((err) => {
            console.error(err);
            throw err;
        });
}
